export const DEFAULT_PARTNER_LEGAL_INFO = {
  legalEntityName: 'Партнерская кофейня',
  ogrnip: '—',
  email: '—',
  supportNote: '(реквизиты партнера будут добавлены)',
};

// Ключи должны быть строками id кофеен, например: "12"
export const PARTNER_LEGAL_BY_SHOP_ID = {
  "2": {
    legalEntityName: "Индивидуальный предприниматель Кузнецов Александр Владимирович",
    ogrnip: "311504403800017",
    email: "-",
    supportNote: "Партнерская кофейня",
  },
};

export const getPartnerLegalInfoByShopId = (shopId) => {
  if (shopId == null) {
    return DEFAULT_PARTNER_LEGAL_INFO;
  }

  const normalizedShopId = String(shopId);
  return PARTNER_LEGAL_BY_SHOP_ID[normalizedShopId] || DEFAULT_PARTNER_LEGAL_INFO;
};
